import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ExternalLinkProvider } from "@/contexts/ExternalLinkContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import Index from "./pages/Index";

const MenuPage = lazy(() => import("./pages/MenuPage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const AvisoLegalPage = lazy(() => import("./pages/AvisoLegalPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const CookiePolicyPage = lazy(() => import("./pages/CookiePolicyPage"));
const LocalSEOPage = lazy(() => import("./pages/LocalSEOPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const MejorSushiBarcelona = lazy(() => import("./pages/blog/MejorSushiBarcelona"));
const QueEsSushiTipos = lazy(() => import("./pages/blog/QueEsSushiTipos"));
const BuffetLibreJaponesBarcelona = lazy(() => import("./pages/blog/BuffetLibreJaponesBarcelona"));
const DondeComerCercaSants = lazy(() => import("./pages/blog/DondeComerCercaSants"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <ExternalLinkProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <main>
              <Suspense fallback={null}>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/galeria" element={<GalleryPage />} />
                  <Route path="/nosotros" element={<AboutPage />} />
                  <Route path="/contacto" element={<ContactPage />} />
                  <Route path="/aviso-legal" element={<AvisoLegalPage />} />
                  <Route path="/politica-de-privacidad" element={<PrivacyPolicyPage />} />
                  <Route path="/politica-de-cookies" element={<CookiePolicyPage />} />
                  <Route path="/restaurante-japones-barcelona" element={<LocalSEOPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/mejor-sushi-barcelona" element={<MejorSushiBarcelona />} />
                  <Route path="/blog/que-es-sushi-tipos" element={<QueEsSushiTipos />} />
                  <Route path="/blog/buffet-libre-japones-barcelona" element={<BuffetLibreJaponesBarcelona />} />
                  <Route path="/blog/donde-comer-cerca-estacion-sants" element={<DondeComerCercaSants />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
            <StickyCTA />
            <CookieConsent />
          </BrowserRouter>
        </TooltipProvider>
      </ExternalLinkProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
